import { useEffect, useState } from "react";
import IconButton from "../../../../components/IconButton";
import Spinner from "../../../../components/Spinner";
import { IconX } from "../../../../icons";

export default function ModalError({ status, users, exit }: any) {
  const [spinner, setSpinner] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setSpinner(false);
    }, 800);
  }, [users]);
  return (
    <>
      <div className="overlay"></div>
      <div className="modalContainer errorDetails">
        <div className="modalTitle">
          <h1>Não foi possivel consolidar os profissionais:</h1>
          <IconButton className="iconX" icon={IconX} onClick={() => exit(false)} />
        </div>
        <Spinner className="spinner" status={spinner}>
          <div className="modalBody">
            <div className="timesheetTableContainer tableContainer">
              <table className="table-container-header-body">
                {users?.length ? (
                  <>
                    <thead>
                      <tr>
                        <th className="header-left">Nome</th>
                        <th className="header-left">Email</th>
                        <th className="header-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <TBodyTime list={users} />
                    </tbody>
                  </>
                ) : (
                  <div className="nothing-list">
                    <h1>Não há registros para a busca realizada.</h1>
                  </div>
                )}
              </table>
            </div>
          </div>
        </Spinner>
      </div>
    </>
  );
}

function TBodyTime({ list, editable }: any) {
  return list?.map((row: any, index: any) => {
    const { id, name, email } = row;
    return (
      <>
        <tr className={`${index % 2 !== 0 && "rowGrey"}`} id={String(id)} key={index}>
          <td>{name}</td>

          <td>{email}</td>
          <td>Já teve suas horas fechadas!</td>
        </tr>
      </>
    );
  });
}
